<template>
  <table class="table is-fullwidth is-striped">
    <thead>
      <tr>
        <th></th>
        <th></th>
        <th>Status</th>
        <th>Email</th>
        <th>Id</th>
        <th>Name</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="member in members" :key="member.id">
        <td>
          <span
            class="tag is-success"
            v-if="userIsAdmin(member)">admin</span>

          <span
            class="tag is-light"
            v-if="userIsHuntLeader(member)">hunt leader</span>

          <span
            class="tag is-light"
            v-if="userIsAfterSearch(member)">after search</span>
        </td>
        <td>
          <button class="button is-text is-size-6 has-text-danger"
            v-if="canRemoveUser(member)"
            @click="removeMember(member)">
            Remove
          </button>
        </td>
        <td>
          <span :class="statusTextClass(member)">{{ member.status }}</span>
        </td>
        <td>
          <span>{{ member.email }}</span>
        </td>
        <td>
          <span v-if="member.userId">{{ member.userId }}_LLUser</span>
        </td>
        <td>
          <span>{{ member.firstName }} {{ member.lastName }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "HuntMembersList",

  props: {
    hunt: {
      type: Object,
      required: true
    },
    members: {
      type: Array,
      required: true
    }
  },

  methods: {
    statusTextClass(user) {
      if (user.status === "invited") {
        return {
          "has-text-info": true
        };
      }

      if (user.status === "member") {
        return {
          "has-text-success": true
        };
      }

      if (user.status === "declined") {
        return {
          "has-text-danger": true
        };
      }

      return {};
    },

    userIsAdmin(user) {
      return user.id === this.hunt.createdBy;
    },

    userIsHuntLeader(user) {
      return user.id === this.hunt.huntLeaderUserId;
    },

    userIsAfterSearch(user) {
      return user.id === this.hunt.afterSearchUserId;
    },

    canRemoveUser(user) {
      return user.id !== this.hunt.createdBy &&
        user.status !== "declined";
    },

    removeMember(member) {
      this.$emit('remove-member', member);
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}

td .button {
  padding: 0px;
  height: 1.5em;
}

td {
  .tag {
    margin-right: 0.5em;
  }
}

</style>
